import {Meta, Period} from "@/edinet/types"
import {FetchNewsArgs as BackendFetchNewsArgs, FetchNewsRes as BackendFetchNewsRes, SetNews as BackendSetNews} from "../../../gcp/doc-index/functions/src/set/types";

export type FetchNewsArgs = BackendFetchNewsArgs
export type FetchNewsRes = BackendFetchNewsRes
export type SetNews = BackendSetNews

export interface SetMeta extends Meta {
    kind: 'SetMeta'
    title: string
    linkText: string
}

export enum SetDocType {
    FinancialStatement,
    MDA,
    Summary
}

export interface SetFilingMeta extends Meta {
    kind: 'SetFilingMeta'
    setDocType: SetDocType
    title: string
    linkText: string
    dateFYEnd: Date
    datePeriodEnd: Date
    period: Period
    year: number
}